declare var Drupal:any;
declare var once:any;

export class Player {

    protected autoPlay;
    protected autoStop;
    protected isPlaying:boolean=false;
    protected moveListener=(ev:JQuery.TriggeredEvent)=>this.timeoutControl();
    protected singlePlayer;
    protected timeOut?:number;
    protected touchControled;
    protected firstStart = true;
    protected noTimeOut=false;

    constructor(protected element:JQuery<HTMLVideoElement|HTMLAudioElement>, protected container:JQuery) {
        this.autoPlay=this.css('autoplay','','string');
        this.autoStop=this.css('autostop','false','bool');
        this.singlePlayer=this.css('single','true','bool');
        this.touchControled = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
        if(this.element) this.element.on('canplay', ()=>this.container.removeClass('loading'));
        if(this.element.data('player') == 'autoplay') this.runAutoPlay();
    }

    protected css(prop:string,def:string,type:string='string') {
        let r=this.element.css('--player-'+prop)??undefined;

        if (typeof r=='string') r=r.trim();
        if (r===undefined) r=def;
        if (type=='duration') {
            if (r.match(/(ms)$/)) return parseFloat(r);
            if (r.match(/(s)$/)) return parseFloat(r)*1000;
            return parseFloat(r);
            }
        if (type=='bool') {
            if (r=='false') return false;
            if (r=='true') return true;
            throw 'Invalid boolean property value for property "'+prop+'"';
        }
        return r;
    }

    protected runAutoPlay() {
        this.container.removeClass('restart');
        this.element.removeClass('restart');
        this.element.on('click keydown',(ev)=>{this.togglePlay(ev)});

        if(window.matchMedia(`(prefers-reduced-motion: reduce)`).matches !== true){
            this.container.addClass('ready');
            setTimeout(()=>{this.play(false)},1);
        }
    }

    public play(e:JQuery.TriggeredEvent|false) {
        if (this.element[0].paused) this.togglePlay(e);
    };

    public pause(e:JQuery.TriggeredEvent|false) {
        if (!this.element[0].paused) this.togglePlay(e);
    };

    public togglePlay(e:JQuery.TriggeredEvent|false) {
        if (e) {
            if(e.type=="keydown" && e.key != " " && e.key != "Enter") {
                return;
            } else {
                if(e) e.preventDefault();
            }
        }

        this.isPlaying = this.element[0].paused;

        let skipState = !this.firstStart && this.touchControled && !this.container.hasClass('active-controls');

        if (this.firstStart) {
            this.firstStart = false;
            this.container.addClass('played');
            this.container.find('[tabindex="-1"]').attr("tabindex",0);
            if(this.element.data('player') != 'autoplay') this.timeoutControl();
        }

        if (!skipState && !this.element[0].controls) {
            this.element[0][!this.isPlaying ? 'pause' : 'play']();
            this.container.removeClass('restart').toggleClass('play', this.isPlaying).toggleClass('pause', !this.isPlaying);
            this.textSwitch(this.element);
        }

        if (this.isPlaying) {
            if (!this.touchControled) {
                this.container.on("mousemove",this.moveListener);
                this.container.trigger('player.stop');
            }
            if (this.singlePlayer) this.container.trigger('player.started',[this.container]);
        } else {
            this.container.off("mousemove",this.moveListener);
        }

        if (this.touchControled) {
            this.timeoutControl();
        }
    }

    protected textSwitch(el:JQuery<HTMLElement>) {
        let save = el.attr('title') as string;
        el.attr('title',el.data('alternate'));
        el.data('alternate',save);
    }

    protected timeoutControl() {
        clearTimeout(this.timeOut);

        this.container.addClass('active-controls');

        if(!this.isPlaying || this.noTimeOut) return;

        this.timeOut = window.setTimeout(()=>{
            this.container.removeClass('active-controls');
        },3000);
    }

    static init() {
        Drupal.behaviors.metadatapreload={
            attach: function (context:HTMLElement|Document, settings:any) {
                once('preload',$(context).find('[preload="none"]:is(video,audio)')).forEach((e:HTMLVideoElement|HTMLAudioElement)=>{
                    // $(e).prop('preload','metadata');
                    $(e).parent().addClass('ready');
                });
            }
        }

        Drupal.behaviors.autoplay={
            attach: function (context:HTMLElement|Document, settings:any) {
                once('autoplay',$(context).find('[data-player="autoplay"]:is(video,audio)')).forEach((e:HTMLVideoElement|HTMLAudioElement)=>{
                    new Player($(e),$(e).closest('figure')??$(e));
                });
            }
        }
    }
}
Player.init();

export {};